import Vue from 'vue'
import confirm from '@/components/confirmation-modal/confirm.vue'
export default Vue.extend({
  name: 'Complete',
  components: {
    confirm
  },
  data () {
    return{
      content: `contents/${this.$route.params.id}`,
    }
  }
})
